import React, { useState } from 'react';
import IeemPublishTab from './IeemPublishTab';
import IeemFlyerTab from './IeemFlyerTab';
import IeemIframeTab from './IeemIframeTab';
import EmptyStateBlock from './bundling/EmptyStateBlock';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

const IeemWorkspaceTabs = ({ activeIeemTab, onTabChange, memberCode, productsContent, analyticsContent }) => {
  const [channelTab, setChannelTab] = useState('publish');

  return (
    <Tabs value={String(activeIeemTab)} onValueChange={(v) => onTabChange(Number(v))}>
      <TabsList className="mb-2 grid w-full max-w-md grid-cols-3">
        <TabsTrigger value="0">Products</TabsTrigger>
        <TabsTrigger value="1">Channels</TabsTrigger>
        <TabsTrigger value="2">Analytics</TabsTrigger>
      </TabsList>

      <TabsContent value="0" className="mt-0">
        {productsContent}
      </TabsContent>

      <TabsContent value="1" className="mt-0">
        <p className="mb-3 text-sm text-slate-600">
          Publish guide, flyer, dan iframe dikelompokkan sebagai satu keluarga channel readiness.
        </p>
        <Tabs value={channelTab} onValueChange={setChannelTab}>
          <TabsList className="mb-2 h-auto flex-wrap gap-2 bg-muted/60 p-1">
            <TabsTrigger value="publish" className="rounded-full">
              Publish Guide
            </TabsTrigger>
            <TabsTrigger value="flyer" className="rounded-full">
              Flyer
            </TabsTrigger>
            <TabsTrigger value="iframe" className="rounded-full">
              Iframe
            </TabsTrigger>
          </TabsList>
          <TabsContent value="publish" className="px-0">
            <IeemPublishTab memberCode={memberCode} />
          </TabsContent>
          <TabsContent value="flyer" className="px-0">
            <IeemFlyerTab memberCode={memberCode} />
          </TabsContent>
          <TabsContent value="iframe" className="px-0">
            <IeemIframeTab memberCode={memberCode} />
          </TabsContent>
        </Tabs>
      </TabsContent>

      <TabsContent value="2" className="mt-0">
        {analyticsContent || (
          <EmptyStateBlock
            title="Analytics summary belum tersedia"
            description="Ringkasan analytics dan exception mapping akan muncul saat integrasi data sudah tersedia."
          />
        )}
      </TabsContent>
    </Tabs>
  );
};

export default IeemWorkspaceTabs;
